import { WidgetUIPhase } from '../types';
import { useWidgetUIPhase } from './useWidgetUIPhase';

export type UseIsEndWidgetUIPhaseArg = {
  widgetId: string;
};

const END_WIDGET_UI_PHASE = [
  WidgetUIPhase.INTERACTIVE_TIMED_OUT,
  WidgetUIPhase.EXPIRED,
];

export const useIsEndWidgetUIPhase = ({
  widgetId,
}: UseIsEndWidgetUIPhaseArg) => {
  const widgetUIPhase = useWidgetUIPhase({ widgetId });
  return END_WIDGET_UI_PHASE.includes(widgetUIPhase);
};
